import { catalogApi } from "@infrastructure/api";
import { catalogReviewsApiResponseSchema, } from "../models/catalog-review.schema";
export const catalogReviewRepository = {
    async getServiceReviews(serviceId, params) {
        const response = await catalogApi.getServiceReviews(serviceId, params);
        const parsed = catalogReviewsApiResponseSchema.parse(response.data);
        return { items: parsed.data, pagination: parsed.meta.pagination };
    },
};
export default catalogReviewRepository;
